import React, { Fragment } from "react";

import { Input } from "reactstrap";

const ContentOrderMetaForm = (props) => {
  const {
    h1,
    title,
    description,
    slug,
    setContentOrderMetaTitle,
    setContentOrderMetaDescription,
    setContentOrderMetaSlug,
    setContentOrderMetaH1,
    setMetaFormValidity,
  } = props;

  const validateForm = () => {
    console.log(props);
    if (
      props.title.length < 1 ||
      props.description.length < 1 ||
      props.slug.length < 1 ||
      props.h1.length < 1
    ) {
      setMetaFormValidity(false);
    } else {
      setMetaFormValidity(true);
    }
  };

  return (
    <Fragment>
      <form onChange={() => validateForm()}>
        <Input
          type="text"
          className="form-control mb-2"
          placeholder="H1"
          value={h1}
          onChange={(event) => {
            setContentOrderMetaH1(event.target.value);
          }}
        />
        <Input
          type="textarea"
          rows="3"
          className="form-control mb-2"
          placeholder="Meta Description for Content Order"
          value={description}
          onChange={(event) => {
            setContentOrderMetaDescription(event.target.value);
          }}
        />
        <Input
          type="text"
          className="form-control mb-2"
          placeholder="/slug-for-content-order"
          value={slug}
          onChange={(event) => {
            setContentOrderMetaSlug(event.target.value);
          }}
        />
        <Input
          type="text"
          className="form-control mb-2"
          placeholder="Meta Title for Content Order"
          value={title}
          onChange={(event) => {
            setContentOrderMetaTitle(event.target.value);
          }}
        />
      </form>
      {description.length > 142 || title.length > 60 || title.length < 51 ? (
        <div id="meta-alerts" className="text-center mt-1 border border-danger">
          {description.length > 142 && (
            <Fragment>
              <span>
                Description too long! {description.length} | 142 characters.
              </span>
              <br />
            </Fragment>
          )}
          {title.length > 60 && (
            <Fragment>
              <span>Title too long! {title.length} | 60 characters.</span>
              <br />
            </Fragment>
          )}
          {title.length < 51 && (
            <Fragment>
              <span>Title too short! {title.length} | 51 characters.</span>
              <br />
            </Fragment>
          )}
        </div>
      ) : (
        <Fragment />
      )}
    </Fragment>
  );
};

export default ContentOrderMetaForm;
